import React from "react";

const Export = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div id="page-header">
                    <h1>Експорт товарів</h1>
                </div>

                <div className="row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <div className="card card-default">
                            <div className="card-header">Виберіть магазин</div>
                            <div className="card-body">
                                <select name="store_id" className="form-select">
                                    <option value="0">Не вибрано</option>
                                    <option value="38">==== Base ViFi ====</option>
                                    <option value="23">Geeg</option>
                                    <option value="60">Melofon</option>
                                    <option value="32">Seven Online</option>
                                    <option value="45">Vdud Online</option>
                                    <option value="37">ViFi Darnytsya</option>
                                    <option value="67">ViFi iClouds</option>
                                    <option value="82">ViFi iClouds 5sssssssssssssssss</option>
                                    <option value="79">ViFi iClouds Good</option>
                                    <option value="51">ViFi Ready To Sale</option>
                                    <option value="42">Vifi Repair</option>
                                    <option value="2">ViFi Yurkivska</option>
                                    <option value="44">ViFi Склад</option>
                                    <option value="53">ViFi Склад Аксесуари</option>
                                    <option value="87">ViFi Склад Аксесуари Android</option>
                                    <option value="39">Vobbi Chernihivska</option>
                                    <option value="65">Vobbi Dnipro</option>
                                    <option value="71">Vobbi Dragomanova</option>
                                    <option value="29">Vobbi Frankivsk</option>
                                    <option value="76">Vobbi Kharkiv</option>
                                    <option value="63">Vobbi Khmelnytsk</option>
                                    <option value="40">Vobbi Leningradska</option>
                                    <option value="46">YNL Beresteika</option>
                                    <option value="80">YNL BK</option>
                                    <option value="72">YNL Heroiv</option>
                                    <option value="30">YNL Kiev</option>
                                    <option value="54">YNL Obolon</option>
                                    <option value="66">Yountel Kafedralna</option>
                                    <option value="25">Yountel Online</option>
                                    <option value="43">Сервісний центр ViFi</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <div className="card card-default">
                            <div className="card-header">Виберіть категорію</div>
                            <div className="card-body">
                                <select name="category_id" className="form-select">
                                    <option value="0">Не вибрано</option>
                                    <option value="27">Аксесуари</option>
                                    <option value="6">Телефони</option>
                                    <option value="11">&nbsp;&nbsp;&nbsp;&nbsp;iPhone</option>
                                    <option value="7">&nbsp;&nbsp;&nbsp;&nbsp;Смартфони</option>
                                    <option value="9">Планшети</option>
                                    <option value="25">Ноутбуки та комп'ютери</option>
                                    <option value="15">Фото та відеотехніка</option>
                                    <option value="28">Ігрова техніка</option>
                                    <option value="16">Інше</option>
                                    <option value="30">Запчастини</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <a href="#" id="start" className="add btn btn-primary">
                    Створити файл експорту
                </a>
                <br />
                <br />
                <div className="alert alert-success alert-download" style={{ display: "block" }}>
                    Файл експорту успішно створено, якщо завантаження файлу не почалось автоматично, натисніть{" "}
                    <a href="files/export/export.csv">«Завантажити»</a>
                </div>
            </div>
        </div>
    );
};

export default Export;
